import { CapitalizePipe } from '../../../common/pipes/capitalize.pipe';

export interface ContractStatus {
  key: string;
  displayText?: string;
}

// Utility class for interacting with ContractStatus objects.
export class ContractStatuses {
  public static fromKey(key: string): ContractStatus {
    if (!key) {
      return ContractStatuses.fromKey('unknown');
    }
    return {
      key: key,
      displayText: new CapitalizePipe().transform(key),
    };
  }
}
